// extracted by mini-css-extract-plugin
export default {"bsz":"style_bsz__qSbWZ","bgImage":"style_bgImage__ivuJ+","spinner":"style_spinner__bh6Ub","loading":"style_loading__-zvvu","fa":"style_fa__RHlT4","sizer":"style_sizer__UAQDL"};